//////LIBRARY//////
import React, { useEffect, useState, Fragment } from 'react'
import moment from 'moment'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { map, cloneDeep, isUndefined, isEqual, isNull, isEmpty } from 'lodash'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { kioskEditSetupActionCreators } from '../../../../store/actions'
import Button from '../../../../components/Ui/Buttons'
import CalendarInputInline from '../../../../components/CalendarInputInline'
import Modals from '../../../../components/Modals'
import { uriList } from '../../../../routings/settings/RouteList'
import theme from '../../../../theme/theme'
import {
	InputWrapper,
	InputLogin,
	SelectInputWrapper,
	ErrorInputMsg,
	LabelText,
	PageWrapperPart,
	PageWrapperPartHandler,
	PageWrapperLinks,
	PageWrapperActions,
	PageWrapperActionReset,
	PageWrapperActionValidate,
	OptionCustom,
	SelectInputCustom,
	TextModalList,
} from '../../../../theme/GlobalCss'
import Tooltip from '../../../../components/Tooltip/Tooltip'
import TooltipHelp from '../../../../components/TooltipHelp'
import UseDatePicker from '../../../../hooks/UseDatePicker'
import KioskPdvHelper from '../../../../helpers/KioskPdvHelper'
import ToggleFilters from '../../../../components/Ui/ToggleFilters'
//////ASSETS//////
import ViewProduction from '../../../../assets/icones/global/eye-file-blue.svg'

//////STYLED//////
const KioskEditSetUpWrapper = styled.div`
	position: relative;
`
const Title = styled.div`
	font-weight: ${theme.weight.bold};
	color: ${theme.colors.primary};
`
const SelectInputDetailHandler = styled.div`
	& > div > a {
		position: absolute;
		right: -85px;
		text-decoration: underline;
		color: ${(props) => props.theme.colors.primary};
		cursor: pointer;
	}
	& > div {
		align-items: center;
	}
`
// STYLED COMMERCIAL BLOC
const KioskCreationDefinitionBusinessTitlePart = styled.span`
	line-height: 32px;
	height: 32px;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};
	display: block;
	padding-left: 15px;
	font-weight: bold;
	margin-bottom: 10px;
	margin-top: 10px;
`
const TextModalListCustom = styled(TextModalList)`
	grid-template-columns: repeat(2, minmax(min-content, max-content));
`
// STYLED COMPANY
const KioskCreationDefinitionBusinessInfo = styled.div`
	padding: 12px;
	background-color: ${(props) => (props.themed === 'white' ? 'transparent' : props.theme.infoPart.background)};
	border: ${(props) => (props.themed === 'white' ? `1px solid ${props.theme.infoPart.borderBlue}` : 'none')};
	& > div:first-child {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	& > div:first-child span {
		font-weight: bold;
		color: ${(props) => props.theme.colors.primary};
	}
	& > div:first-child img {
		cursor: pointer;
	}
`
const KioskCreationDefinitionBusinessInfoPart = styled.div`
	display: grid;
	grid-template-columns: max-content min-content;
	grid-column-gap: 15px;
	grid-row-gap: 5px;
`

const KioskCreationDefinitionBusinessContentPart = styled.div`
	display: grid;
	grid-row-gap: 20px;
	grid-template-columns: auto;
	padding: 0px 10px 10px 10px;
	margin-top: 10px;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
`
// STYLED KIOSK INFORMATIONS
const KioskCreationDefinitionBusinessTogglePart = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-row-gap: 25px;
	margin: 20px 10px;
	& > div {
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
	}
`
const KioskCodeWDLabel = styled.span`
	color: ${(props) => props.theme.colors.error};
	margin-left: 5px;
	line-height: 13px;
`
// STYLED TECHNICAL INFORMATIONS BLOC
const ProductionSheetWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(min-content, max-content));
	grid-auto-flow: column;
	grid-column-gap: 20px;
	align-items: center;
`
const PageWrapperPartHandlerCustom = styled(PageWrapperPartHandler)`
	grid-template-columns: repeat(3, minmax(min-content, 1fr));
`
//////STYLED//////

const KioskEditSetup = () => {
	let history = useHistory()

	const { translations, kioskEditSetUpItemDetail } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			kioskEditSetUp: state.kioskEditSetUp,
			kioskEditSetUpItemDetail: state.kioskEditSetUp.itemDetail,
			//idCurrentCompanyTyped: state.user.identity.idCompanyTyped
		}),
		shallowEqual
	)
	const match = useRouteMatch()
	const actionsKioskEditSetUp = bindActionCreators(kioskEditSetupActionCreators, useDispatch())

	const [stateDefaultValues, setStateDefaultValues] = useState({})

	const { register, handleSubmit, watch, errors, setValue, getValues, control, reset } = useForm({
		defaultValues: stateDefaultValues,
	})

	// Page title
	const [pageTitle, setPageTitle] = useState('')

	// Toogle

	const [profile, setProfile] = useState({})
	const [idStoreSelected, setIdStoreSelected] = useState(null)
	const [idKioskMainteneur, setIdKioskMainteneur] = useState(null)

	// Modals
	const [showModalOwnerDetail, setShowModalOwnerDetail] = useState(false)
	const [showModalStoreManagerDetail, setShowModalStoreManagerDetail] = useState(false)
	const [showModalStoreDetail, setShowModalStoreDetail] = useState(false)
	const [showModalDistributorDetail, setShowModalDistributorDetail] = useState(false)
	const [showModalResellerDetail, setShowModalResellerDetail] = useState(false)
	const [showModalCompanyCreate, setShowModalCompanyCreate] = useState(false)
	const [showModalCompaniesManager, setShowModalCompaniesManager] = useState(false)
	const [showModalMaintainerDetail, setShowModalMaintainerDetail] = useState(false)

	// Details modal config
	const [detailModalConfig, setDetailModalConfig] = useState()

	// Label Details modal config
	const [labelDetailModalConfig, setLabelDetailModalConfig] = useState({
		labelCn: 'modal__kiosk__in__production__modify__companyName_label',
		labelSiret: 'modal__kiosk__in__production__modify__siret_label',
		labelAddress: 'modal__kiosk__in__production__modify__address_label',
		labelZipCode: 'modal__kiosk__in__production__modify__zipCode_label',
		labelCity: 'modal__kiosk__in__production__modify__city_label',
		labelCountry: 'modal__kiosk__in__production__modify__country_label',
		labelDivisions: 'modal__kiosk__in__production__modify__divisions_label',
	})

	const [row, setRow] = useState({})

	/////////////////////////////// HANDLER //////////////////////////////////////

	const onSubmit = (data) => {
		const bodyMessage = {
			installationDate: !isUndefined(currentRealInstallationDate?.date?.startDate) ? currentRealInstallationDate.date.startDate : null,
			expeditionDate: !isUndefined(shipmentDateStateDate?.date?.startDate) ? shipmentDateStateDate.date.startDate : null,
			customerAvailabilityDate: !isUndefined(currentProvidedGuestDate?.date?.startDate) ? currentProvidedGuestDate.date.startDate : null,
			commissioningDate: !isUndefined(currentCommissioningDate?.date?.startDate) ? currentCommissioningDate.date.startDate : null,
			idStore: parseInt(data.store),
			idMaintainer: parseInt(data.maintainer),
			customerKioskCode: data.kioskLabelToOwner,
			kioskName: data.kioskDescription,
			ticketByMailAvailable: data.ticketByMailAvailable,
			solarPanelAvailable: data.solarPanelAvailable,
		}
		actionsKioskEditSetUp.putEditKioskSetup(match.params.id, bodyMessage)
	}

	// Modal handlers
	const handleOpenModals = (row = {}, modal) => {
		setRow(row)
		switch (modal) {
			case 'handleModalOwner':
				setShowModalOwnerDetail(true)
				break
			case 'handleModalReseller':
				setShowModalResellerDetail(true)
				break
			case 'handleModalStoreManager':
				setShowModalStoreManagerDetail(true)
				break
			case 'handleModalStore':
				setShowModalStoreDetail(true)
				break
			case 'handleModalDistributor':
				setShowModalDistributorDetail(true)
				break
			case 'handleModalMaintainer':
				setShowModalMaintainerDetail(true)
				break
			default:
				break
		}
	}

	const handleCloseModals = (_dataRow) => {
		if (showModalOwnerDetail) {
			setShowModalOwnerDetail(false)
		}
		if (showModalResellerDetail) {
			setShowModalResellerDetail(false)
		}
		if (showModalStoreManagerDetail) {
			setShowModalStoreManagerDetail(false)
		}
		if (showModalStoreDetail) {
			setShowModalStoreDetail(false)
		}
		if (showModalDistributorDetail) {
			setShowModalDistributorDetail(false)
		}
		if (showModalCompanyCreate) {
			setShowModalCompanyCreate(false)
		}
		if (showModalCompaniesManager) {
			setShowModalCompaniesManager(false)
		}
		if (showModalMaintainerDetail) {
			setShowModalMaintainerDetail(false)
		}
	}

	// Toggle handler

	const handleProfileSelectedChange = (switchesCase) => {
		const profileCp = cloneDeep(profile)

		switch (switchesCase) {
			case 'ticketByMailAvailable':
				setValue('ticketByMailAvailable', !profileCp.ticketByMailAvailable)
				profileCp.ticketByMailAvailable = !profileCp.ticketByMailAvailable
				break
			case 'solarPanelAvailable':
				setValue('solarPanelAvailable', !profileCp.solarPanelAvailable)
				profileCp.solarPanelAvailable = !profileCp.solarPanelAvailable
				break

			default:
				break
		}

		setProfile(profileCp)
	}

	const handleRedirect = () => {
		history.push(`${uriList.kiosksInProduction}${uriList.kioskProductionList}`)
	}

	const handleReset = () => {
		setCurrentRealInstallationDateStateDate({
			...currentRealInstallationDate,
			date: { startDate: undefined },
		})
		setCurrentShipmentDateStateDate({
			...currentShipmentDate,
			date: { startDate: undefined },
		})
		setCurrentProvidedGuestDateStateDate({
			...currentProvidedGuestDate,
			date: { startDate: undefined },
		})
		setCurrentCommissioningDateStateDate({
			...currentCommissioningDate,
			date: { startDate: undefined },
		})
		reset()
	}

	const handleViewProductFile = (id) => {
		actionsKioskEditSetUp.viewProductionFile(id)
	}
	//////////////////////////////////////////CONFIG DATE PICKER////////////////////////////

	// use date picker

	const [
		validityEndDateShowModal,
		validityEndDateOpenDateModalHandler,
		validityEndDateRenderModal,
		validityEndDateStateDate,
		validityEndDateStartDate,
		validityEndDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})

	const [
		installationRequestedDateShowModal,
		installationRequestedDateOpenDateModalHandler,
		installationRequestedDateRenderModal,
		installationRequestedDateStateDate,
		installationRequestedDateStartDate,
		installationRequestedDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})

	const [
		expectedDeliveryDateShowModal,
		expectedDeliveryDateOpenDateModalHandler,
		expectedDeliveryDateRenderModal,
		expectedDeliveryDateStateDate,
		expectedDeliveryDateStartDate,
		expectedDeliveryDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})

	const [
		realInstallationDateShowModal,
		realInstallationDateModalHandler,
		realInstallationDateRenderModal,
		realInstallationDateStateDate,
		realInstallationDateStartDate,
		realInstallationDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})
	const [
		shipmentDateShowModal,
		shipmentDateModalHandler,
		shipmentDateRenderModal,
		shipmentDateStateDate,
		shipmentDateStartDate,
		shipmentDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})
	const [
		providedGuestDateShowModal,
		providedGuestDateModalHandler,
		providedGuestDateRenderModal,
		providedGuestDateStateDate,
		providedGuestDateStartDate,
		providedGuestDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})
	const [
		commissioningDateShowModal,
		commissioningDateModalHandler,
		commissioningDateRenderModal,
		commissioningDateStateDate,
		commissioningDateStartDate,
		commissioningDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})
	const [
		warrantyEndDateShowModal,
		warrantyEndDateModalHandler,
		warrantyEndDateRenderModal,
		warrantyEndDateStateDate,
		warrantyEndDateStartDate,
		warrantyEndDateEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		priorEndLimit: moment().toDate(),
		defaultDateStart: moment().toDate(),
	})

	// use state
	const [currentValidityEndDate, setCurrentValidityEndDateStateDate] = useState(validityEndDateStateDate)
	const [currentInstallationRequestedDate, setCurrentInstallationRequestedDateStateDate] = useState(installationRequestedDateStateDate)
	const [currentExpectedDeliveryDate, setCurrentExpectedDeliveryDateStateDate] = useState(expectedDeliveryDateStateDate)
	const [currentRealInstallationDate, setCurrentRealInstallationDateStateDate] = useState(realInstallationDateStateDate)
	const [currentShipmentDate, setCurrentShipmentDateStateDate] = useState(shipmentDateStateDate)
	const [currentProvidedGuestDate, setCurrentProvidedGuestDateStateDate] = useState(providedGuestDateStateDate)
	const [currentCommissioningDate, setCurrentCommissioningDateStateDate] = useState(commissioningDateStateDate)
	const [currentWarrantyEndDate, setCurrentWarrantyEndDateStateDate] = useState(warrantyEndDateStateDate)

	// config date picker commented with hope to refact it, currently config object cause render problem
	//	const [configDatePicker, setConfigDatePicker] = useState([])
	/* useEffect(() => {
		setConfigDatePicker([
			 {
		//We comment this part because this is a futur feature
		name: 'validityEndDate',
		label: 'page_admin_initKiosk_stepOne_sheet_kiosk_deliveryDate',
		required: true,
		disabled: false,
		onClickHandler: validityEndDateOpenDateModalHandler,
		valuInput: !isUndefined(currentValidityEndDate.date.startDate) ? `${moment(currentValidityEndDate.date.startDate).format('DD/MM/YYYY')}` : ""
	}, 
			{
				name: 'installationRequestedDate',
				label: 'page__kiosk__in__production__modify__admin__installationDate_label',
				required: true,
				disabled: true,
				//onClickHandler:null ,
				valueInput: !isUndefined(currentInstallationRequestedDate.date.startDate) ? `${moment(currentInstallationRequestedDate.date.startDate).format('DD/MM/YYYY')}` : ""
			},
			{
				name: 'expectedDeliveryDate',
				label: 'page__kiosk__in__production__modify__admin__expectedDeliveryDate_label',
				disabled: true,
				//onClickHandler: null,
				valueInput: !isUndefined(currentExpectedDeliveryDate.date.startDate) ? `${moment(currentExpectedDeliveryDate.date.startDate).format('DD/MM/YYYY')}` : ""
			},
			{
				name: 'realInstallationDate',
				label: 'page__kiosk__in__production__modify__admin__realInstallationDate_label',
				disabled: false,
				onClickHandler: realInstallationDateModalHandler,
				valueInput: !isUndefined(currentRealInstallationDate.date.startDate) ? `${moment(currentRealInstallationDate.date.startDate).format('DD/MM/YYYY')}` : ""
			},
			{
				name: 'shipmentDate',
				label: 'page__kiosk__in__production__modify__admin__shipmentDate_label',
				disabled: false,
				onClickHandler: shipmentDateModalHandler,
				valueInput: !isUndefined(currentShipmentDate.date.startDate) ? `${moment(currentShipmentDate.date.startDate).format('DD/MM/YYYY')}` : ""

			},
			{
				name: 'providedGuestDate',
				label: 'page__kiosk__in__production__modify__admin__providedGuestDate_label',
				disabled: false,
				onClickHandler: providedGuestDateModalHandler,
				valueInput: !isUndefined(currentProvidedGuestDate.date.startDate) ? `${moment(currentProvidedGuestDate.date.startDate).format('DD/MM/YYYY')}` : ""
			},
			{
				name: 'commissioningDate',
				label: 'page__kiosk__in__production__modify__admin__commissioningDate_label',
				disabled: false,
				onClickHandler: commissioningDateModalHandler,
				valueInput: !isUndefined(currentCommissioningDate.date.startDate) ? `${moment(currentCommissioningDate.date.startDate).format('DD/MM/YYYY')}` : ""
			},
			{
				name: 'warrantyEndDate',
				label: 'page__kiosk__in__production__modify__admin__WarrantyEndDate_label',
				disabled: true,
				onClickHandler: warrantyEndDateModalHandler,
				valueInput: !isUndefined(currentWarrantyEndDate.date.startDate) ? `${moment(currentWarrantyEndDate.date.startDate).format('DD/MM/YYYY')}` : "",
				toolTipHelp: true,
				content: 'tooltipHelp__admin__modal__body___kiosk__in__production__modify__calculatedData',
				pos: 1,
			},
		]) 

}, [translations, currentInstallationRequestedDate, currentExpectedDeliveryDate, currentRealInstallationDate, currentShipmentDate, currentProvidedGuestDate, currentCommissioningDate, currentWarrantyEndDate])*/

	useEffect(() => {
		if (validityEndDateStateDate.showModal) {
			setCurrentValidityEndDateStateDate(validityEndDateStateDate)
		}
	}, [validityEndDateShowModal])

	useEffect(() => {
		if (realInstallationDateStateDate.showModal) {
			setCurrentRealInstallationDateStateDate(realInstallationDateStateDate)
		}
	}, [realInstallationDateShowModal])

	useEffect(() => {
		if (shipmentDateStateDate.showModal) {
			setCurrentShipmentDateStateDate(shipmentDateStateDate)
		}
	}, [shipmentDateShowModal])

	useEffect(() => {
		if (providedGuestDateStateDate.showModal) {
			setCurrentProvidedGuestDateStateDate(providedGuestDateStateDate)
		}
	}, [providedGuestDateShowModal])

	useEffect(() => {
		if (commissioningDateStateDate.showModal) {
			setCurrentCommissioningDateStateDate(commissioningDateStateDate)
		}
	}, [commissioningDateShowModal])

	useEffect(() => {
		if (warrantyEndDateStateDate.showModal) {
			setCurrentWarrantyEndDateStateDate(warrantyEndDateStateDate)
		}
	}, [warrantyEndDateShowModal])

	///////////////////////////////////////CONFIG DETAIL MODALS///////////////////////////////

	// To set value according commercial infos specificity
	const [kioskOwner, setKioskOwner] = useState([])
	const [kioskStoreManager, setKioskStoreManager] = useState([])
	const [kioskStore, setKioskStore] = useState([])
	const [kioskDistributor, setKioskDistributor] = useState([])
	const [kioskReseller, setKioskReseller] = useState([])
	const [kioskMainteneur, setKioskMainteneur] = useState([])

	// set labels and values on different details modals
	useEffect(() => {
		if (!isUndefined(kioskEditSetUpItemDetail.kioskOwner) || isNull(kioskEditSetUpItemDetail.kioskOwner)) {
			setKioskOwner([
				{
					label: labelDetailModalConfig.labelCn,
					span: kioskEditSetUpItemDetail.kioskOwner?.details.companyName,
				},
				{
					label: labelDetailModalConfig.labelSiret,
					span: kioskEditSetUpItemDetail.kioskOwner?.details.siret,
				},
				{
					label: labelDetailModalConfig.labelAddress,
					span: kioskEditSetUpItemDetail.kioskOwner?.details.address,
				},
				{
					label: labelDetailModalConfig.labelZipCode,
					span: kioskEditSetUpItemDetail.kioskOwner?.details.postalCode,
				},
				{
					label: labelDetailModalConfig.labelCity,
					span: kioskEditSetUpItemDetail.kioskOwner?.details.city,
				},
				{
					label: labelDetailModalConfig.labelCountry,
					span: kioskEditSetUpItemDetail.kioskOwner?.details.country,
				},
				{
					label_div: labelDetailModalConfig.labelDivisions,
					span_div: kioskEditSetUpItemDetail.kioskOwner?.details.companyDivisions,
				},
			])
		}
		if (!isUndefined(kioskEditSetUpItemDetail.kioskStoreManager) || !isNull(kioskEditSetUpItemDetail.kioskStoreManager)) {
			setKioskStoreManager([
				{
					label: labelDetailModalConfig.labelCn,
					span: kioskEditSetUpItemDetail.kioskStoreManager?.details.companyName,
				},
				{
					label: labelDetailModalConfig.labelSiret,
					span: kioskEditSetUpItemDetail.kioskStoreManager?.details.siret,
				},
				{
					label: labelDetailModalConfig.labelAddress,
					span: kioskEditSetUpItemDetail.kioskStoreManager?.details.address,
				},
				{
					label: labelDetailModalConfig.labelZipCode,
					span: kioskEditSetUpItemDetail.kioskStoreManager?.details.postalCode,
				},
				{
					label: labelDetailModalConfig.labelCity,
					span: kioskEditSetUpItemDetail.kioskStoreManager?.details.city,
				},
				{
					label: labelDetailModalConfig.labelCountry,
					span: kioskEditSetUpItemDetail.kioskStoreManager?.details.country,
				},
				{
					label_div: labelDetailModalConfig.labelDivisions,
					span_div: kioskEditSetUpItemDetail.kioskStoreManager?.details.companyDivisions,
				},
			])
		}
		if (!isUndefined(kioskEditSetUpItemDetail.stores) || !isNull(kioskEditSetUpItemDetail.stores)) {
			if (!isNull(idStoreSelected)) {
				let store
				kioskEditSetUpItemDetail.stores.map((element) => {
					if (element?.id == idStoreSelected) store = { ...element }
				})
				setKioskStore([
					{
						label: labelDetailModalConfig.labelCn,
						span: store.details.companyName,
					},
					{
						label: labelDetailModalConfig.labelSiret,
						span: store.details.siret,
					},
					{
						label: labelDetailModalConfig.labelAddress,
						span: store.details.address,
					},
					{
						label: labelDetailModalConfig.labelZipCode,
						span: store.details.postalCode,
					},
					{
						label: labelDetailModalConfig.labelCity,
						span: store.details.city,
					},
					{
						label: labelDetailModalConfig.labelCountry,
						span: store.details.country,
					},
					{
						label_div: labelDetailModalConfig.labelDivisions,
						span_div: store.details.companyDivisions,
					},
				])
			} else {
				map(kioskEditSetUpItemDetail.stores, (elem) => {
					setKioskStore([
						{
							label: labelDetailModalConfig.labelCn,
							span: elem?.details.companyName,
						},
						{
							label: labelDetailModalConfig.labelSiret,
							span: elem?.details.siret,
						},
						{
							label: labelDetailModalConfig.labelAddress,
							span: elem?.details.address,
						},
						{
							label: labelDetailModalConfig.labelZipCode,
							span: elem?.details.postalCode,
						},
						{
							label: labelDetailModalConfig.labelCity,
							span: elem?.details.city,
						},
						{
							label: labelDetailModalConfig.labelCountry,
							span: elem?.details.country,
						},
						{
							label_div: labelDetailModalConfig.labelDivisions,
							span_div: elem?.details.companyDivisions,
						},
					])
				})
			}
		}
		if (!isUndefined(kioskEditSetUpItemDetail.kioskDistributor) || !isNull(kioskEditSetUpItemDetail.kioskDistributor)) {
			setKioskDistributor([
				{
					label: labelDetailModalConfig.labelCn,
					span: kioskEditSetUpItemDetail.kioskDistributor?.details.companyName,
				},
				{
					label: labelDetailModalConfig.labelSiret,
					span: kioskEditSetUpItemDetail.kioskDistributor?.details.siret,
				},
				{
					label: labelDetailModalConfig.labelAddress,
					span: kioskEditSetUpItemDetail.kioskDistributor?.details.address,
				},
				{
					label: labelDetailModalConfig.labelZipCode,
					span: kioskEditSetUpItemDetail.kioskDistributor?.details.postalCode,
				},
				{
					label: labelDetailModalConfig.labelCity,
					span: kioskEditSetUpItemDetail.kioskDistributor?.details.city,
				},
				{
					label: labelDetailModalConfig.labelCountry,
					span: kioskEditSetUpItemDetail.kioskDistributor?.details.country,
				},
				{
					label_div: labelDetailModalConfig.labelDivisions,
					span_div: kioskEditSetUpItemDetail.kioskDistributor?.details.companyDivisions,
				},
			])
		}
		if (!isUndefined(kioskEditSetUpItemDetail.kioskReseller) || !isNull(kioskEditSetUpItemDetail.kioskReseller)) {
			setKioskReseller([
				{
					label: labelDetailModalConfig.labelCn,
					span: kioskEditSetUpItemDetail.kioskReseller?.details.companyName,
				},
				{
					label: labelDetailModalConfig.labelSiret,
					span: kioskEditSetUpItemDetail.kioskReseller?.details.siret,
				},
				{
					label: labelDetailModalConfig.labelAddress,
					span: kioskEditSetUpItemDetail.kioskReseller?.details.address,
				},
				{
					label: labelDetailModalConfig.labelZipCode,
					span: kioskEditSetUpItemDetail.kioskReseller?.details.postalCode,
				},
				{
					label: labelDetailModalConfig.labelCity,
					span: kioskEditSetUpItemDetail.kioskReseller?.details.city,
				},
				{
					label: labelDetailModalConfig.labelCountry,
					span: kioskEditSetUpItemDetail.kioskReseller?.details.country,
				},
				{
					label_div: labelDetailModalConfig.labelDivisions,
					span_div: kioskEditSetUpItemDetail.kioskReseller?.details.companyDivisions,
				},
			])
		}
		if (
			!isUndefined(kioskEditSetUpItemDetail.maintainers) ||
			!isNull(kioskEditSetUpItemDetail.maintainers) ||
			!isEqual(kioskEditSetUpItemDetail.maintainers, [])
		) {
			if (!isNull(idKioskMainteneur)) {
				let store
				kioskEditSetUpItemDetail.maintainers.map((element) => {
					if (element?.id == idKioskMainteneur) store = { ...element }
				})
				setKioskMainteneur([
					{
						label: labelDetailModalConfig.labelCn,
						span: store.details.companyName,
					},
					{
						label: labelDetailModalConfig.labelSiret,
						span: store.details.siret,
					},
					{
						label: labelDetailModalConfig.labelAddress,
						span: store.details.address,
					},
					{
						label: labelDetailModalConfig.labelZipCode,
						span: store.details.postalCode,
					},
					{
						label: labelDetailModalConfig.labelCity,
						span: store.details.city,
					},
					{
						label: labelDetailModalConfig.labelCountry,
						span: store.details.country,
					},
					{
						label_div: labelDetailModalConfig.labelDivisions,
						span_div: store.details.companyDivisions,
					},
				])
			} else {
				map(kioskEditSetUpItemDetail.maintainers, (elem) =>
					setKioskMainteneur([
						{
							label: labelDetailModalConfig.labelCn,
							span: elem?.details.companyName,
						},
						{
							label: labelDetailModalConfig.labelSiret,
							span: elem?.details.siret,
						},
						{
							label: labelDetailModalConfig.labelAddress,
							span: elem?.details.address,
						},
						{
							label: labelDetailModalConfig.labelZipCode,
							span: elem?.details.postalCode,
						},
						{
							label: labelDetailModalConfig.labelCity,
							span: elem?.details.city,
						},
						{
							label: labelDetailModalConfig.labelCountry,
							span: elem?.details.country,
						},
						{
							label_div: labelDetailModalConfig.labelDivisions,
							span_div: elem?.details.companyDivisions,
						},
					])
				)
			}
		}
	}, [kioskEditSetUpItemDetail, idStoreSelected, idKioskMainteneur])

	useEffect(() => {
		setDetailModalConfig([
			{
				title: translations['modal__kiosk__in__production__modify__ownerDetails_title'],
				showModal: showModalOwnerDetail,
				closeModalHandler: handleCloseModals,
				icon: true,
				text: kioskOwner,
			},
			{
				title: translations['page_admin_initKiosk_stepOne_sheet_linkTo_storeManagerDetails'],
				showModal: showModalStoreManagerDetail,
				closeModalHandler: handleCloseModals,
				icon: true,
				text: kioskStoreManager,
			},
			{
				title: translations['modal__kiosk__in__production__modify__storeDetails_title'],
				showModal: showModalStoreDetail,
				closeModalHandler: handleCloseModals,
				icon: true,
				text: kioskStore,
			},
			{
				title: translations['modal__kiosk__in__production__modify__distributorDetails_title'],
				showModal: showModalDistributorDetail,
				closeModalHandler: handleCloseModals,
				icon: true,
				text: kioskDistributor,
			},
			{
				title: translations['modal__kiosk__in__production__modify__resellerDetails_title'],
				showModal: showModalResellerDetail,
				closeModalHandler: handleCloseModals,
				icon: true,
				text: kioskReseller,
			},
			{
				title: translations['modal__kiosk__in__production__modify__maintainerDetails_title'],
				showModal: showModalMaintainerDetail,
				closeModalHandler: handleCloseModals,
				icon: true,
				text: kioskMainteneur,
			},
		])
	}, [
		kioskEditSetUpItemDetail,
		showModalOwnerDetail,
		showModalStoreManagerDetail,
		showModalStoreDetail,
		showModalDistributorDetail,
		showModalDistributorDetail,
		showModalResellerDetail,
		showModalMaintainerDetail,
		idStoreSelected,
	])

	/////////////////////////////////////////////////USE EFFECT//////////////////////////////////

	// getAll
	useEffect(() => {
		if (isEmpty(translations)) return
		actionsKioskEditSetUp.getKioskSetup(match.params.id)
	}, [translations])

	//set Title
	useEffect(() => {
		if (!isUndefined(kioskEditSetUpItemDetail.kioskOwner)) {
			setPageTitle(
				`${translations['page__kiosk__in__production__modify__admin__itemTable_subTitle']} ${kioskEditSetUpItemDetail.kioskOwner?.companyName} - ${kioskEditSetUpItemDetail.kioskCode} - ${kioskEditSetUpItemDetail.kioskName}`
			)
		}
	}, [kioskEditSetUpItemDetail.kioskOwner, translations])

	// on data loaded
	useEffect(() => {
		const profileCp = cloneDeep(profile)
		if (!isUndefined(kioskEditSetUpItemDetail)) {
			setValue('kioskLabelToOwner', kioskEditSetUpItemDetail.customerKioskCode)
			setValue('kioskDescription', kioskEditSetUpItemDetail.kioskName)

			if (!isUndefined(kioskEditSetUpItemDetail.ticketByMailAvailable)) {
				setValue('ticketByMailAvailable', kioskEditSetUpItemDetail.ticketByMailAvailable)
			}
			if (!isUndefined(kioskEditSetUpItemDetail.solarPanelAvailable)) {
				setValue('solarPanelAvailable', kioskEditSetUpItemDetail.solarPanelAvailable)
			}

			profileCp.ticketByMailAvailable = kioskEditSetUpItemDetail.ticketByMailAvailable
			profileCp.solarPanelAvailable = kioskEditSetUpItemDetail.solarPanelAvailable
			setProfile(profileCp)

			// SET DATE
			if (!isNull(kioskEditSetUpItemDetail.installationDateRequested) && !isUndefined(kioskEditSetUpItemDetail.installationDateRequested)) {
				setValue('installationRequestedDate', moment(kioskEditSetUpItemDetail.installationDateRequested).format('DD/MM/YYYY'))
				currentInstallationRequestedDate.date.startDate = moment(kioskEditSetUpItemDetail.installationDateRequested).toDate()
				installationRequestedDateStartDate(moment(kioskEditSetUpItemDetail.installationDateRequested).toDate())
			}
			if (!isNull(kioskEditSetUpItemDetail.dateDeliveryScheduled) && !isUndefined(kioskEditSetUpItemDetail.dateDeliveryScheduled)) {
				setValue('expectedDeliveryDate', moment(kioskEditSetUpItemDetail.dateDeliveryScheduled).format('DD/MM/YYYY'))
				currentExpectedDeliveryDate.date.startDate = moment(kioskEditSetUpItemDetail.dateDeliveryScheduled).toDate()
				expectedDeliveryDateStartDate(moment(kioskEditSetUpItemDetail.dateDeliveryScheduled).toDate())
			}
			if (!isNull(kioskEditSetUpItemDetail.installationDate) && !isUndefined(kioskEditSetUpItemDetail.installationDate)) {
				setValue('realInstallationDate', moment(kioskEditSetUpItemDetail.installationDate).format('DD/MM/YYYY'))
				currentRealInstallationDate.date.startDate = moment(kioskEditSetUpItemDetail.installationDate).toDate()
				realInstallationDateStartDate(moment(kioskEditSetUpItemDetail.installationDate).toDate())
			}
			if (!isNull(kioskEditSetUpItemDetail.expeditionDate) && !isUndefined(kioskEditSetUpItemDetail.expeditionDate)) {
				setValue('shipmentDate', moment(kioskEditSetUpItemDetail.expeditionDate).format('DD/MM/YYYY'))
				currentShipmentDate.date.startDate = moment(kioskEditSetUpItemDetail.expeditionDate).toDate()
				shipmentDateStartDate(moment(kioskEditSetUpItemDetail.expeditionDate).toDate())
			}
			if (!isNull(kioskEditSetUpItemDetail.customerAvailabilityDate) && !isUndefined(kioskEditSetUpItemDetail.customerAvailabilityDate)) {
				setValue('providedGuestDate', moment(kioskEditSetUpItemDetail.customerAvailabilityDate).format('DD/MM/YYYY'))
				currentProvidedGuestDate.date.startDate = moment(kioskEditSetUpItemDetail.customerAvailabilityDate).toDate()
				providedGuestDateStartDate(moment(kioskEditSetUpItemDetail.customerAvailabilityDate).toDate())
			}
			if (!isNull(kioskEditSetUpItemDetail.commissioningDate) && !isUndefined(kioskEditSetUpItemDetail.commissioningDate)) {
				setValue('commissioningDate', moment(kioskEditSetUpItemDetail.commissioningDate).format('DD/MM/YYYY'))
				currentCommissioningDate.date.startDate = moment(kioskEditSetUpItemDetail.commissioningDate).toDate()
				commissioningDateStartDate(moment(kioskEditSetUpItemDetail.commissioningDate).toDate())
			}
			if (!isNull(kioskEditSetUpItemDetail.customerAvailabilityDate) && !isUndefined(kioskEditSetUpItemDetail.customerAvailabilityDate)) {
				setValue(
					'warrantyDate',
					moment(kioskEditSetUpItemDetail.customerAvailabilityDate)
						.add(kioskEditSetUpItemDetail.kioskWarrantyInteger, 'year')
						.format('DD/MM/YYYY')
				)
				currentWarrantyEndDate.date.startDate = moment(kioskEditSetUpItemDetail.customerAvailabilityDate)
					.add(kioskEditSetUpItemDetail.kioskWarrantyInteger, 'year')
					.toDate()
				warrantyEndDateStartDate(
					moment(kioskEditSetUpItemDetail.commissioningDate).add(kioskEditSetUpItemDetail.kioskWarrantyInteger, 'year').toDate()
				)
			}
		}
	}, [translations, kioskEditSetUpItemDetail])

	// When changing store manager
	const handleStoreChange = (idStoreManager) => {
		setIdStoreSelected(idStoreManager)
	}

	const handleMainteneurChange = (idKioskMainteneur) => {
		setIdKioskMainteneur(idKioskMainteneur)
	}

	///////////////////////////////////////RENDER/////////////////////////////////////////

	return (
		<Fragment>
			{/* DATE PICKER MODAL */}
			{validityEndDateRenderModal()}
			{realInstallationDateRenderModal()}
			{shipmentDateRenderModal()}
			{providedGuestDateRenderModal()}
			{commissioningDateRenderModal()}
			{warrantyEndDateRenderModal()}

			{/* DETAILS MODAL */}
			{map(detailModalConfig, (elem, _key) => (
				<Modals title={elem.title} showModal={elem.showModal} closeModalHandler={elem.closeModalHandler} icon={elem.icon}>
					<TextModalWrapper>
						<TextModalList>
							{map(elem.text, (e, _key) => (
								<>
									<LabelText>{translations[e.label] ? `${translations[e.label]} :` : null}</LabelText>
									<span>{e.span}</span>
								</>
							))}
						</TextModalList>
						<TextModalList>
							<div style={{ display: 'flex', flexDirection: 'row' }}>
								<LabelText>{translations[elem.text[6]?.label_div] ? `${translations[elem.text[6]?.label_div]} :` : null} </LabelText>
								{map(elem.text[6]?.span_div, (v, _k) => (
									/*   <div style={{ marginLeft: '5px' }}>{e.span_div?.length > (e.span_div?.length - 1) ? `${translations[v]},` : translations[v]}</div> */
									<div style={{ marginLeft: '5px' }}>{translations[v]}</div>
								))}
							</div>
						</TextModalList>
					</TextModalWrapper>
				</Modals>
			))}

			{/* TITLE AND ACTIONS */}
			{
				<KioskEditSetUpWrapper>
					<PageWrapperLinks>
						<Button
							goBack
							weight="bold"
							//actionHandler={ () => {history.push(`${ uriList.users }${ uriList.usersManager }`)} }
							actionHandler={() => handleRedirect()}
							text={translations['common__text__previousPage']}
						/>
					</PageWrapperLinks>
					<Title>{pageTitle}</Title>
					<form onSubmit={handleSubmit(onSubmit)}>
						<PageWrapperActions>
							<Tooltip tooltipId={'userDetailSubmit'} translationsKey={'tooltip__admin__global__save'}>
								<PageWrapperActionValidate type="submit" />
							</Tooltip>
							<Tooltip tooltipId={'userDetailReset'} translationsKey={'tooltip__admin__global__reset'}>
								<PageWrapperActionReset onClick={() => handleReset()} />
							</Tooltip>
						</PageWrapperActions>
						<PageWrapperPartHandlerCustom>
							{/* FIRST COLUMN */}
							<PageWrapperPart>
								{/* COMMERCIAL INFORMATIONS */}
								<KioskCreationDefinitionBusinessTitlePart>
									{translations['page__kiosk__in__production__modify__admin__sheet_commercialInformation_blocTitle']}
								</KioskCreationDefinitionBusinessTitlePart>

								{/*     We comment this part this is a futur feature
                        <ToggleShortcutWrapper marginBottom='20px' justifyItems='left'>
                                {todo : traduction }
                                <LabelText>Borne active :</LabelText>
                                <Controller
                                    control={control}
                                    name="enabled"
                                    as={ToggleInput}
                                    checked={userEnabled}
                                    onChangeHandler={() => {
                                        setUserEnabled((prevState) => !prevState)
                                    }}
                                    rules={register({
                                        required: {
                                            value: true,
                                            message: translations['common__text__requiredField'],
                                        },
                                    })}
                                    labelPrev
                                    labelNext
                                />
                            </ToggleShortcutWrapper> */}

								{/* DATE PICKER * if we can refact and use config file ! at this moment we have a render problem we must f5 to see date inside input/}
                       {/*          {
                                    map(configDatePicker, elem => (
                                        <div style={{ marginBottom: '20px' }}>
                                            {
                                                elem.toolTipHelp ?
                                                    <TooltipHelp
                                                        childrenPos={elem.pos}
                                                        insideModal={true}
                                                        content={elem.content}
                                                    >
                                                        <LabelText>{(!isUndefined(elem.label) && translations[elem.label])}{(!isUndefined(elem.required) ? "*" : null)} :</LabelText>
                                                    </TooltipHelp>
                                                    :
                                                    <LabelText>{(!isUndefined(elem.label) && translations[elem.label])}{(!isUndefined(elem.required) ? "*" : null)} :</LabelText>
                                            }
                                            <CalendarInputInline
                                                name={!isUndefined(elem.name) && elem.name}
                                                disabled={!isUndefined(elem.disabled) && elem.disabled}
                                                onClickHandler={!isUndefined(elem.onClickHandler) && elem.onClickHandler}
                                                valueInput={!isUndefined(elem.valueInput) ? elem.valueInput : ""}
                                            //valueInput={elem.valueInput}
                                            />
                                            {errors.elem?.name && <ErrorInputMsg>{errors.elem?.name?.message}</ErrorInputMsg>}
                                        </div>
                                    ))
                                } */}
								{/* DATE PICKER 2*/}
								<div style={{ marginBottom: '20px' }}>
									<LabelText>{translations['page__kiosk__in__production__modify__admin__installationDate_label']}* :</LabelText>
									<CalendarInputInline
										name="installationRequestedDate"
										disabled={true}
										onClickHandler={null}
										valueInput={
											!isUndefined(currentInstallationRequestedDate.date.startDate)
												? `${moment(currentInstallationRequestedDate.date.startDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
								</div>
								<div style={{ marginBottom: '20px' }}>
									<LabelText>{translations['page__kiosk__in__production__modify__admin__expectedDeliveryDate_label']} :</LabelText>
									<CalendarInputInline
										name="expectedDeliveryDate"
										disabled={true}
										onClickHandler={null}
										valueInput={
											!isUndefined(currentExpectedDeliveryDate.date.startDate)
												? `${moment(currentExpectedDeliveryDate.date.startDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
									{errors.elem?.name && <ErrorInputMsg>{errors.elem?.name?.message}</ErrorInputMsg>}
								</div>
								<div style={{ marginBottom: '20px' }}>
									<LabelText>{translations['page__kiosk__in__production__modify__admin__realInstallationDate_label']} :</LabelText>
									<CalendarInputInline
										name="realInstallationDate"
										disabled={false}
										onClickHandler={realInstallationDateModalHandler}
										valueInput={
											!isUndefined(currentRealInstallationDate.date.startDate)
												? `${moment(currentRealInstallationDate.date.startDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
									{errors.realInstallationDate && <ErrorInputMsg>{errors.realInstallationDate}</ErrorInputMsg>}
								</div>
								<div style={{ marginBottom: '20px' }}>
									<LabelText>{translations['page__kiosk__in__production__modify__admin__shipmentDate_label']} :</LabelText>
									<CalendarInputInline
										name="shipmentDate"
										disabled={false}
										onClickHandler={shipmentDateModalHandler}
										valueInput={
											!isUndefined(currentShipmentDate.date.startDate)
												? `${moment(currentShipmentDate.date.startDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
									{errors.shipmentDate && <ErrorInputMsg>{errors.shipmentDate}</ErrorInputMsg>}
								</div>
								<div style={{ marginBottom: '20px' }}>
									<LabelText>{translations['page__kiosk__in__production__modify__admin__providedGuestDate_label']} :</LabelText>
									<CalendarInputInline
										name="providedGuestDate"
										disabled={false}
										onClickHandler={providedGuestDateModalHandler}
										valueInput={
											!isUndefined(currentProvidedGuestDate.date.startDate)
												? `${moment(currentProvidedGuestDate.date.startDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
									{errors.providedGuestDate && <ErrorInputMsg>{errors.providedGuestDate}</ErrorInputMsg>}
								</div>
								<div style={{ marginBottom: '20px' }}>
									<LabelText>{translations['page__kiosk__in__production__modify__admin__commissioningDate_label']} :</LabelText>
									<CalendarInputInline
										name="commissioningDate"
										disabled={false}
										onClickHandler={commissioningDateModalHandler}
										valueInput={
											!isUndefined(currentCommissioningDate.date.startDate)
												? `${moment(currentCommissioningDate.date.startDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
									{errors.commissioningDate && <ErrorInputMsg>{errors.commissioningDate}</ErrorInputMsg>}
								</div>
								<div style={{ marginBottom: '20px' }}>
									<TooltipHelp
										childrenPos={1}
										insideModal={true}
										content={'tooltipHelp__admin__modal__body___kiosk__in__production__modify__calculatedData'}
									>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__WarrantyEndDate_label']} :</LabelText>
									</TooltipHelp>
									<CalendarInputInline
										name="warrantyEndDate"
										disabled={true}
										//onClickHandler={commissioningDateModalHandler}
										valueInput={
											!isUndefined(currentWarrantyEndDate.date.startDate)
												? `${moment(currentWarrantyEndDate.date.startDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
									{errors.warrantyEndDate && <ErrorInputMsg>{errors.warrantyEndDate}</ErrorInputMsg>}
								</div>

								{/* COMPANY INFORMATIONS */}
								<KioskCreationDefinitionBusinessTitlePart>
									{translations['page__kiosk__in__production__modify__admin__sheet_companyInformation_blocTitle']}
								</KioskCreationDefinitionBusinessTitlePart>
								<KioskCreationDefinitionBusinessContentPart>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_owner']}* :</LabelText>
										<SelectInputDetailHandler>
											<SelectInputWrapper>
												<InputLogin
													type="text"
													name="owner"
													disabled
													placeholder={'NA'}
													value={kioskEditSetUpItemDetail.kioskOwner?.companyName}
												/>
												{
													/* !isUndefined(currentOwner) && */ <a onClick={() => handleOpenModals({}, 'handleModalOwner')}>
														{translations['page__kiosk__in__production__modify__admin__sheet__linkTo_viewDetails']}
													</a>
												}
											</SelectInputWrapper>
											{errors.owner && <ErrorInputMsg>{errors.owner.message}</ErrorInputMsg>}
										</SelectInputDetailHandler>
									</div>
									{
										/* !stockRequestCheck && */ <div>
											<SelectInputDetailHandler>
												<LabelText>
													{translations['page__kiosk__in__production__modify_admin__sheet_storeManager']} :
												</LabelText>
												<SelectInputWrapper>
													<InputLogin
														type="text"
														name="storeManager"
														disabled
														placeholder={'NA'}
														value={kioskEditSetUpItemDetail.kioskStoreManager?.companyName}
													/>
													{
														/* !isUndefined(currentStoreManager) && */ <a
															onClick={() => handleOpenModals({}, 'handleModalStoreManager')}
														>
															{translations['page__kiosk__in__production__modify__admin__sheet__linkTo_viewDetails']}
														</a>
													}
												</SelectInputWrapper>
												{errors.storeManager && <ErrorInputMsg>{errors.storeManager.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									}

									{
										/* !stockRequestCheck &&  */ <div>
											<SelectInputDetailHandler>
												<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_store']}* :</LabelText>
												<SelectInputWrapper>
													<SelectInputCustom
														width="280"
														name="store"
														ref={register({
															required: {
																value: true,
																message: translations['common__text__requiredField'],
															},
															validate: (value) => value > 0 || translations['common__text__requiredField'],
														})}
														className={watch('store') > 0 ? 'active' : ''}
														onChange={(e) => handleStoreChange(e.target.value)}
													>
														<OptionCustom value="0" hidden>
															{translations['page__kiosk__in__production__modify__admin__sheet__store_placeholder']}
														</OptionCustom>
														{!isUndefined(kioskEditSetUpItemDetail) &&
															map(kioskEditSetUpItemDetail.stores, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																		{elem.details.companyName}
																	</OptionCustom>
																)
															})}
													</SelectInputCustom>
													{
														/* !isUndefined(currentStore) && */ <a
															onClick={() => handleOpenModals({}, 'handleModalStore')}
														>
															{translations['page__kiosk__in__production__modify__admin__sheet__linkTo_viewDetails']}
														</a>
													}
												</SelectInputWrapper>
												{errors.store && <ErrorInputMsg>{errors.store.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									}
									<div>
										<SelectInputDetailHandler>
											<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_distributor']}* :</LabelText>
											<SelectInputWrapper>
												<InputLogin
													width="280"
													type="text"
													name="distributor"
													disabled
													placeholder={'NA'}
													value={kioskEditSetUpItemDetail.kioskDistributor?.companyName}
												/>
												{
													/* !isUndefined(currentDistributor) && */ <a
														onClick={() => handleOpenModals({}, 'handleModalDistributor')}
													>
														{translations['page__kiosk__in__production__modify__admin__sheet__linkTo_viewDetails']}
													</a>
												}
											</SelectInputWrapper>
											{errors.distributor && <ErrorInputMsg>{errors.distributor.message}</ErrorInputMsg>}
										</SelectInputDetailHandler>
									</div>
									{
										/* !stockRequestCheck && */ <div>
											<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_reseller']}* :</LabelText>
											<SelectInputDetailHandler>
												<SelectInputWrapper>
													<InputLogin
														type="text"
														name="reseller"
														disabled
														placeholder={'NA'}
														value={kioskEditSetUpItemDetail.kioskReseller?.companyName}
													/>
													{
														/* !isUndefined(currentReseller) && */ <a
															onClick={() => handleOpenModals({}, 'handleModalReseller')}
														>
															{translations['page__kiosk__in__production__modify__admin__sheet__linkTo_viewDetails']}
														</a>
													}
												</SelectInputWrapper>
												{errors.reseller && <ErrorInputMsg>{errors.reseller.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									}

									{
										/* !stockRequestCheck &&  */ <div>
											<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_maintainer']}* :</LabelText>
											<SelectInputDetailHandler>
												<SelectInputWrapper>
													<SelectInputCustom
														//name="reseller"
														name="maintainer"
														width="208"
														ref={register({
															required: {
																value: true,
																message: translations['common__text__requiredField'],
															},
															validate: (value) => value > 0 || translations['common__text__requiredField'],
														})}
														className={watch('maintainer') > 0 ? 'active' : ''}
														onChange={(e) => handleMainteneurChange(e.target.value)}
													>
														<OptionCustom value="0" hidden>
															{translations['page__kiosk__in__production__modify__admin__sheet_maintainer']}
														</OptionCustom>
														{!isUndefined(kioskEditSetUpItemDetail) &&
															map(kioskEditSetUpItemDetail.maintainers, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																		{elem.details.companyName}
																	</OptionCustom>
																)
															})}
													</SelectInputCustom>
													{
														/* !isUndefined(currentMaintainer) && */ <a
															onClick={() => handleOpenModals({}, 'handleModalMaintainer')}
														>
															{translations['page__kiosk__in__production__modify__admin__sheet__linkTo_viewDetails']}
														</a>
													}
												</SelectInputWrapper>
												{errors.maintainer && <ErrorInputMsg>{errors.maintainer.message}</ErrorInputMsg>}
											</SelectInputDetailHandler>
										</div>
									}
								</KioskCreationDefinitionBusinessContentPart>
							</PageWrapperPart>
							{/* SECOND COLUMN */}
							<PageWrapperPart>
								{/* KIOSK INFORMATION BLOC */}
								<KioskCreationDefinitionBusinessTitlePart>
									{translations['page__kiosk__in__production__modify__admin__sheet_kioskInformation_blocTitle']}
								</KioskCreationDefinitionBusinessTitlePart>
								<KioskCreationDefinitionBusinessContentPart>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_kioskModel']}* :</LabelText>
										<div>
											<SelectInputWrapper>
												<InputLogin
													type="text"
													name="kioskModel"
													disabled
													placeholder={'NA'}
													value={translations[kioskEditSetUpItemDetail.kioskModel]}
												/>
											</SelectInputWrapper>
											{errors.kioskModel && <ErrorInputMsg>{errors.kioskModel.message}</ErrorInputMsg>}
										</div>
									</div>
								</KioskCreationDefinitionBusinessContentPart>
								{
									/* !stockRequestCheck && */ <Fragment>
										<KioskCreationDefinitionBusinessContentPart>
											<div>
												<LabelText>
													{translations['page__kiosk__in__production__modify_admin__sheet_kioskCode']} :{' '}
													<KioskCodeWDLabel>{kioskEditSetUpItemDetail.kioskCode}</KioskCodeWDLabel>
												</LabelText>
											</div>
											<div>
												<LabelText>
													{translations['page__kiosk__in__production__modify_admin__sheet_customerKioskCode']} :
												</LabelText>
												<InputWrapper>
													<InputLogin
														name="kioskLabelToOwner"
														type="text"
														placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_name_placeholder']}
														ref={register({
															maxLength: {
																value: 250,
																message: `250 ${translations['common__text__charMax']}`,
															},
															minLength: {
																value: 1,
																message: `1 ${translations['common__text__charMin']}`,
															},
															validate: (value) =>
																KioskPdvHelper.isPdvValidOnUpdate(
																	value,
																	getValues('kioskDescription'),
																	kioskEditSetUpItemDetail.customerKioskCode,
																	kioskEditSetUpItemDetail.kioskName
																) || translations['common__message__kiosk_pdv_wrongFormat'],
															required: {
																value: false,
																message: translations['common__text__requiredField'],
															},
														})}
													/>
													{errors.kioskLabelToOwner && <ErrorInputMsg>{errors.kioskLabelToOwner.message}</ErrorInputMsg>}
												</InputWrapper>
											</div>
											<div>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_label']}* :</LabelText>
												<InputWrapper>
													<InputLogin
														width="280"
														name="kioskDescription"
														type="text"
														placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_label_placeholder']}
														ref={register({
															required: {
																value: true,
																message: translations['common__text__requiredField'],
															},
														})}
													/>
													{errors.kioskDescription && <ErrorInputMsg>{errors.kioskDescription.message}</ErrorInputMsg>}
												</InputWrapper>
											</div>
											<div>
												<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_warranty']} :</LabelText>
												<div>
													<SelectInputWrapper>
														<InputLogin
															type="text"
															name="kioskWarranty"
															disabled
															placeholder={'NA'}
															value={kioskEditSetUpItemDetail.kioskWarranty}
														/>
													</SelectInputWrapper>
													{errors.kioskWarranty && <ErrorInputMsg>{errors.kioskWarranty.message}</ErrorInputMsg>}
												</div>
											</div>
										</KioskCreationDefinitionBusinessContentPart>
									</Fragment>
								}
								{
									/* !stockRequestCheck && */ <Fragment>
										<KioskCreationDefinitionBusinessContentPart>
											<div>
												<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_language']}* :</LabelText>

												{translations && (
													/* kioskCreationDefinitionOptions.availableLanguages &&  */ <div>
														<SelectInputWrapper>
															<InputLogin
																type="text"
																name="kioskLanguage"
																disabled
																placeholder={'NA'}
																value={kioskEditSetUpItemDetail.kioskLanguage}
															/>
														</SelectInputWrapper>
														{errors.kioskLanguage && <ErrorInputMsg>{errors.kioskLanguage.message}</ErrorInputMsg>}
													</div>
												)}
											</div>
										</KioskCreationDefinitionBusinessContentPart>
										<KioskCreationDefinitionBusinessTogglePart visible={true}>
											<div>
												<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_pda']} :</LabelText>
												<Controller
													control={control}
													name="pda"
													as={ToggleFilters}
													checked={kioskEditSetUpItemDetail?.pda}
													disabled={true}
													reverseCheck
													size="large"
													rules={register({
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
													})}
													labelPrev={translations['common__text__yes']}
													labelNext={translations['common__text__no']}
												/>
											</div>
										</KioskCreationDefinitionBusinessTogglePart>
										<KioskCreationDefinitionBusinessContentPart>
											<div>
												<LabelText>
													{translations['page__kiosk__in__production__modify_admin__sheet_kioskMessage']} :
												</LabelText>
												<InputWrapper>
													<InputLogin
														name="welcomeMessage"
														disabled={true}
														type="text"
														placeholder={'NA'}
														value={kioskEditSetUpItemDetail.welcomeMessage}
														width={'100%'}
													/>
													{errors.welcomeMessage && <ErrorInputMsg>{errors.welcomeMessage.message}</ErrorInputMsg>}
												</InputWrapper>
											</div>
										</KioskCreationDefinitionBusinessContentPart>
									</Fragment>
								}
								<KioskCreationDefinitionBusinessTogglePart visible={true}>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_solidDoor']} :</LabelText>
										<Controller
											control={control}
											name="solidDoor"
											as={ToggleFilters}
											checked={kioskEditSetUpItemDetail?.solidDoor}
											disabled={true}
											size="large"
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_lateralPanel']} :</LabelText>
										<Controller
											control={control}
											name="lateralPanel"
											as={ToggleFilters}
											checked={kioskEditSetUpItemDetail?.lateralPanel}
											disabled={true}
											size="large"
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_interiorCover']} :</LabelText>
										<Controller
											control={control}
											name="interiorCover"
											as={ToggleFilters}
											checked={kioskEditSetUpItemDetail?.interiorCover}
											disabled={true}
											size="large"
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_restrictedLocation']} :</LabelText>
										<Controller
											control={control}
											name="restrictedLocation"
											as={ToggleFilters}
											checked={kioskEditSetUpItemDetail?.restrictedLocation}
											disabled={true}
											size="large"
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
								</KioskCreationDefinitionBusinessTogglePart>

								{/* KIOSK SETUP OPTION */}
								<KioskCreationDefinitionBusinessTitlePart>
									{translations['page__kiosk__in__production__modify__admin__sheet_kioskConfigInfo_blocTitle']}
								</KioskCreationDefinitionBusinessTitlePart>
								<KioskCreationDefinitionBusinessContentPart>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_kioskConfigInfo']}* :</LabelText>
										<div>
											<SelectInputWrapper>
												<InputLogin
													width="380"
													type="text"
													name="kioskOwnerConfig"
													disabled
													placeholder={'NA'}
													value={kioskEditSetUpItemDetail.kioskConfigurationLabel}
												/>
											</SelectInputWrapper>
											{errors.kioskOwnerConfig && <ErrorInputMsg>{errors.kioskOwnerConfig.message}</ErrorInputMsg>}
										</div>
									</div>
									<div>
										<LabelText>
											{translations['page__kiosk__in__production__modify__admin__sheet_implantationConfig']}* :
										</LabelText>
										<div>
											<SelectInputWrapper>
												<InputLogin
													width="380"
													type="text"
													name="idDisplayStandImplantation"
													disabled
													placeholder={'NA'}
													value={kioskEditSetUpItemDetail.displayStandImplantation}
												/>
											</SelectInputWrapper>
											{errors.idDisplayStandImplantation && (
												<ErrorInputMsg>{errors.idDisplayStandImplantation.message}</ErrorInputMsg>
											)}
										</div>
									</div>
								</KioskCreationDefinitionBusinessContentPart>
								<KioskCreationDefinitionBusinessTogglePart>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_platineSet']} :</LabelText>
										<Controller
											control={control}
											name="platineSet"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.platineSet}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_marker']} :</LabelText>
										<Controller
											control={control}
											name="marker"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.marker}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify_admin__sheet_bottleDetection']} :</LabelText>
										<Controller
											control={control}
											name="bottleDetectionAvailable"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.bottleDetectionAvailable}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_materialMarker']} :</LabelText>
										<Controller
											control={control}
											name="bottleMatterSensor"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.bottleMatterSensor}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>
											{translations['page__kiosk__in__production__modify__admin__sheet_allowPaymentByCode']} :
										</LabelText>
										<Controller
											control={control}
											name="codePaymentAvailable"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.codePaymentAvailable}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_tpa']} :</LabelText>
										<Controller
											control={control}
											name="tpaAvailable"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.tpaAvailable}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpaMOdel']} :</LabelText>
											<SelectInputWrapper>
												<InputLogin
													name="kioskTpaModel"
													disabled={true}
													type="text"
													placeholder={'NA'}
													value={kioskEditSetUpItemDetail.kioskTpaModelLabel}
													width={'100%'}
												/>
											</SelectInputWrapper>
											{errors.kioskTpaModel && <ErrorInputMsg>{errors.kioskTpaModel.message}</ErrorInputMsg>}
										</div>
									</div>
									<div>
										<div>
											<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_integrator']} :</LabelText>
											<SelectInputWrapper>
												<InputLogin
													name="kioskTpaIntegrator"
													disabled={true}
													type="text"
													placeholder={'NA'}
													value={kioskEditSetUpItemDetail.kioskTpaIntegratorLabel}
													width={'100%'}
												/>
											</SelectInputWrapper>
											{errors.kioskTpaIntegrator && <ErrorInputMsg>{errors.kioskTpaIntegrator.message}</ErrorInputMsg>}
										</div>
									</div>
									<div>
										<div>
											<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_connectivity']} :</LabelText>
											<SelectInputWrapper>
												<InputLogin
													name="kioskConnectivity"
													disabled={true}
													type="text"
													placeholder={'NA'}
													value={kioskEditSetUpItemDetail.kioskConnectivityLabel}
													width={'100%'}
												/>
											</SelectInputWrapper>
											{errors.kioskConnectivity && <ErrorInputMsg>{errors.kioskConnectivity.message}</ErrorInputMsg>}
										</div>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_scaleMarker']} :</LabelText>
										<Controller
											control={control}
											name="scaleAvailable"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.scaleAvailable}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_printer']} :</LabelText>
										<Controller
											control={control}
											name="printerAvailable"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.printerAvailable}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>
											{translations['page__kiosk__in__production__modify__admin__sheet_sendCustomerTicket']} :
										</LabelText>
										<Controller
											control={control}
											name="ticketByMailAvailable"
											as={ToggleFilters}
											size="large"
											checked={profile.ticketByMailAvailable}
											reverseCheck
											onChangeHandler={() => {
												handleProfileSelectedChange('ticketByMailAvailable')
											}}
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_solar']} :</LabelText>
										<Controller
											control={control}
											name="solarPanelAvailable"
											as={ToggleFilters}
											size="large"
											checked={profile.solarPanelAvailable}
											reverseCheck
											onChangeHandler={() => {
												handleProfileSelectedChange('solarPanelAvailable')
											}}
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
									<div>
										<LabelText>{translations['page__kiosk__in__production__modify__admin__sheet_bareCoeReader']} :</LabelText>
										<Controller
											control={control}
											name="barCodeReader"
											as={ToggleFilters}
											disabled={true}
											size="large"
											checked={kioskEditSetUpItemDetail?.barCodeReader}
											reverseCheck
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
										/>
									</div>
								</KioskCreationDefinitionBusinessTogglePart>
							</PageWrapperPart>

							{/* THIRD COLUMN */}
							<PageWrapperPart>
								<KioskCreationDefinitionBusinessTitlePart>
									{translations['page__kiosk__in__production__modify__admin__sheet_technicalInformation_blocTitle']}
								</KioskCreationDefinitionBusinessTitlePart>
								<KioskCreationDefinitionBusinessContentPart>
									<div>
										<LabelText
											style={{ marginBottom: '15px' }}
										>{`${translations['page__kiosk__in__production__modify__admin__sheet_productionSheet']} :`}</LabelText>
										<ProductionSheetWrapper>
											<div>
												{!isNull(kioskEditSetUpItemDetail.productionFileName)
													? kioskEditSetUpItemDetail.productionFileName
													: null}
											</div>
											<Tooltip
												translationsKey={'tooltip__admin__global__action__productionSheet_view'}
												tooltipId={'scopeKioskSortKiosk'}
											>
												<img
													src={!isNull(kioskEditSetUpItemDetail.productionFileName) ? ViewProduction : null}
													style={{ cursor: 'pointer' }}
													onClick={() => handleViewProductFile(kioskEditSetUpItemDetail.kioskId)}
												/>
											</Tooltip>
										</ProductionSheetWrapper>
									</div>
								</KioskCreationDefinitionBusinessContentPart>
							</PageWrapperPart>
						</PageWrapperPartHandlerCustom>
					</form>
				</KioskEditSetUpWrapper>
			}
		</Fragment>
	)
}

KioskEditSetup.propTypes = {}

KioskEditSetup.defaultPropTypes = {}

export default KioskEditSetup
